import React from "react";
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { QUOTE_STEPS, FULL_QUOTE_STEPS, PATHS } from "../AppConstants";
import { IAppState } from "../state/interfaces";
import { connect } from "react-redux";
import Utilities from "../classes/Utilities";

interface IProps extends RouteComponentProps {
    vehicleIndex: number,
    goBackVisible: boolean
}

class Header extends React.Component<IProps, any> {

    constructor(props: IProps) {
        super(props);
    }

    goBack(e : any) {
        e.preventDefault();
        console.log(this.props.history);

        if (0 === this.props.vehicleIndex && this.props.history.location.pathname === Utilities.formatUrl(PATHS.VEHICLE_YMM, "")) {
            this.props.history.push(PATHS.CHANGE_ZIP);
        }
        else {
            this.props.history.goBack();
        }
    }

    componentDidMount() {

    }

    render() {
        return (
            <div className="header">
                <div className="header-nav">
                    <a href="" className="back-btn" onClick={(e: any) => this.goBack(e)} style={{ display: this.props.goBackVisible ? "" : "none" }}><i className="fas fa-chevron-left"></i></a>
                    <div className="text-center text-uppercase brand">
                        <img className="site-logo" src="data:image/png;base64,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" />
                            <span>BRAVO GENERAL INSURANCE SERVICES</span>
                    </div>
                </div>
            </div>
        );
    }
}

let mapProps = (state: IAppState, ownProps: any) => {
    var vehicleIndex = !ownProps.match.params["vehicleIndex"]
        ? 0
        : parseInt(ownProps.match.params["vehicleIndex"], 10);

    return {
        vehicleIndex,
        //goBackVisible: !!state.currentStep && (state.currentStep !== QUOTE_STEPS.VEHICLE_YMM && state.currentStep !== QUOTE_STEPS.START)
        goBackVisible: !!state.currentStep
            && (state.currentStep !== QUOTE_STEPS.START
            && state.currentStep !== QUOTE_STEPS.CHANGE_ZIP
            && state.currentStep !== FULL_QUOTE_STEPS.FINISH
            && state.currentStep !== QUOTE_STEPS.RTR_COVERAGES)
        //goBackVisible: true
    }
}

let mapDispatch = (dispatch: any) => {
    return {
    }
}

export default withRouter(connect(mapProps)(Header))
